import React, { useCallback, useState } from "react";
import classNames from "classnames";
import { AutoComplete } from "antd";

import carrierImg100 from "../../images/carrierIcons/100_square.png";
import carrierImg108 from "../../images/carrierIcons/108_square.png";
import carrierImg109 from "../../images/carrierIcons/109_square.png";
import carrierImg121 from "../../images/carrierIcons/121_square.png";
import carrierImg317 from "../../images/carrierIcons/317_square.png";
import carrierImg2050 from "../../images/carrierIcons/2050_square.png";
import carrierImg3628 from "../../images/carrierIcons/3628_square.png";
import carrierImg208 from "../../images/carrierIcons/208_square.png";
import carrierImg291 from "../../images/carrierIcons/291_square.png";
import carrierImg220 from "../../images/carrierIcons/220_square.png";
import carrierImg206 from "../../images/carrierIcons/206_square.png";
import carrierImg264 from "../../images/carrierIcons/264_square.png";
import carrierImg3577 from "../../images/carrierIcons/3577_square.png";
import carrierImg1900 from "../../images/carrierIcons/1900_square.png";

import styles from "./styles.module.scss"

const Typeahead = ({ label, placeholder, className, ...props }) => {
  return (
    <label className={classNames("x-vertical", "x-spacing-4px", className)} {...props}>
      <div>{label}</div>
      <AutoComplete xstyle={{ width: 300 }} options={[
        { value: 0, label: "Accounting & Auditing" }
      ]}>
        <input
          className="form-control"
          placeholder={placeholder}
        />
      </AutoComplete>
    </label>
  );
};

const carriers = [
  { id: 264, name: "CBIC", imageSrc: carrierImg264 },
  { id: 108, name: "CNA", imageSrc: carrierImg108 },
  { id: 2050, name: "Berkshire Hathaway", imageSrc: carrierImg2050 },
  { id: 220, name: "GUARD", imageSrc: carrierImg220 },
  { id: 208, name: "Hiscox", imageSrc: carrierImg208 },
  { id: 121, name: "Liberty Mutual", imageSrc: carrierImg121 },
  { id: 1900, name: "MSA", imageSrc: carrierImg1900 },
  { id: 3628, name: "NatGen", imageSrc: carrierImg3628 },
  { id: 317, name: "Progressive", imageSrc: carrierImg317 },
  { id: 291, name: "Tapco", imageSrc: carrierImg291 },
  { id: 100, name: "The Hartford", imageSrc: carrierImg100 },
  { id: 109, name: "Travelers", imageSrc: carrierImg109 },
  { id: 206, name: "USLI", imageSrc: carrierImg206 },
  { id: 3577, name: "Utica First", imageSrc: carrierImg3577 },
];

const cards = [
  {
    lineOfBusiness: "General Liability", carriersWithAppetite: [
      100, 109, 121, 264, 208,
    ], carriersWithoutAppetite: [
      3577,
    ]
  },
  {
    lineOfBusiness: "Business Owners Policy", carriersWithAppetite: [
      100, 109, 121, 264, 208, 3577,
    ], carriersWithoutAppetite: [
      108,
    ]
  },
  {
    lineOfBusiness: "Workers' Compensation", carriersWithAppetite: [
      100, 109, 121, 108,
    ], carriersWithoutAppetite: [
    ]
  },
  {
    lineOfBusiness: "Errors & Omissions", carriersWithAppetite: [
      100, 109, 121, 264, 208,
    ], carriersWithoutAppetite: [
      3577,
    ]
  },
  {
    lineOfBusiness: "Commercial Auto", carriersWithAppetite: [
      100, 109, 121, 264, 208,
    ], carriersWithoutAppetite: [
      3577,
    ]
  },
  {
    lineOfBusiness: "Inland Marine", carriersWithAppetite: [
      100, 109, 121, 264, 208,
    ], carriersWithoutAppetite: [
      3577,
    ]
  },
  {
    lineOfBusiness: "Cyber", carriersWithAppetite: [
      100, 109, 121, 264, 208,
    ], carriersWithoutAppetite: [
      3577,
    ]
  },
];

//

const Carrier = ({ carrier, selected, inAppetite, onSelect }) => {
  const carrierClassNames = classNames(
    styles.Carrier,
    "x-horizontal x-padding-12px x-spacing-8px x-align-middle-left",
    onSelect && styles.selectable,
    selected && styles.selected
  );

  return (
    <div
      className={carrierClassNames}
      onPointerDown={() => onSelect?.(carrier.id)}
    >
      <img src={carrier.imageSrc} alt="" width={40} />
      <div className="x-flex-1" style={{ fontSize: 16, fontWeight: 600 }}>
        {carrier.name}
      </div>
      <div style={{ width: 24, height: 24, borderRadius: 9999, background: inAppetite ? "#2e7d32" : "#d32f2f" }} />
    </div>
  );
};

//

const Card = ({ card, onCardUpdate }) => {
  const [selectedCarrierIds, setSelectedCarrierIds] = useState([]);

  const carriersWithAppetite = card.carriersWithAppetite.map(carrierId => carriers.find(carrier => carrier.id === carrierId))
    .sort((a, b) => {
      if (a.name > b.name) {
        return 1;
      } else if (a.name < b.name) {
        return -1;
      }

      return 0;
    });
  const carriersWithoutAppetite = card.carriersWithoutAppetite.map(carrierId => carriers.find(carrier => carrier.id === carrierId))
    .sort((a, b) => {
      if (a.name > b.name) {
        return 1;
      } else if (a.name < b.name) {
        return -1;
      }

      return 0;
    });
  ;

  const handleCarrierSelect = useCallback(carrierId => {
    var updatedSelectedCarrierIds;

    if (selectedCarrierIds.includes(carrierId)) {
      updatedSelectedCarrierIds = selectedCarrierIds.filter(id => id !== carrierId);
    } else {
      updatedSelectedCarrierIds = [...selectedCarrierIds, carrierId];
    }

    setSelectedCarrierIds(updatedSelectedCarrierIds);

    onCardUpdate?.(card.lineOfBusiness, updatedSelectedCarrierIds);
  }, [card.lineOfBusiness, onCardUpdate, selectedCarrierIds]);

  return (
    <div>
      <div className="x-vertical x-padding-16px x-spacing-12px" style={{ background: "white", border: "1px solid #d9d8ea" }}>
        <div style={{ fontSize: 20, fontWeight: 600 }}>
          {card.lineOfBusiness}
        </div>
        <div className="x-vertical x-spacing-8px">
          <div style={{ fontSize: 12, xmarginTop: 16, color: "gray" }}>
            Carriers in Appetite
          </div>
          <div className="x-vertical x-spacing-12px">
            {carriersWithAppetite.map((carrier, index) => (
              <Carrier
                carrier={carrier}
                selected={selectedCarrierIds.includes(carrier.id)}
                inAppetite={card.carriersWithAppetite.includes(carrier.id)}
                onSelect={handleCarrierSelect}
              />
            ))}
          </div>
          {carriersWithoutAppetite.length > 0 && (
            <div className="x-vertical x-spacing-8px">
              <div style={{ fontSize: 12, marginTop: 12, color: "gray" }}>
                Carriers out of Appetite
              </div>
              {carriersWithoutAppetite.map((carrier, index) => (
                <Carrier
                  carrier={carrier}
                  inAppetite={card.carriersWithAppetite.includes(carrier.id)}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const AppetiteSearch = () => {
  const [lineOfBusinessMap, setLineOfBusinessMap] = useState({});

  const handleCardUpdate = useCallback((lineOfBusiness, selectedCarrierIds) => {
    setLineOfBusinessMap({
      ...lineOfBusinessMap,
      [lineOfBusiness]: selectedCarrierIds
    })
  }, [lineOfBusinessMap]);

  const totalCarriersSelected = Object.values(lineOfBusinessMap).flatMap(carrierIds => carrierIds).length;

  console.log(totalCarriersSelected);

  return (
    <>
      <div id="appetite-search">
        <h1 className="page-header">Appetite Search</h1>
        <div className="x-vertical x-spacing-24px">
          <div className="x-horizontal x-spacing-16px">
            <Typeahead className="x-flex-1" label="Business Type" placeholder="Search for a business type" />
            <Typeahead label="Line of Business" placeholder="Select a lob" />
            <Typeahead label="State" placeholder="Select a state" />
          </div>
          <div
            className="x-horizontal x-spacing-16px"
            style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr) )" }}
          >
            {cards.map(card => (
              <Card card={card} onCardUpdate={handleCardUpdate} />
            ))}
          </div>
        </div>
      </div>
      <div
        className="x-horizontal x-align-middle-justify"
        style={{
          position: "sticky", bottom: 69,
          //  background: "hsla(216, 20%, 95%, 0.5)",
          // background: "#d9d8ea",
          background: "#f5fafe",
          xbackdropFilter: "blur(20px)", padding: "16px 39px",
          // borderBottom: "1px solid #b2b1c0"
        }}
      >
        <div style={{ fontSize: 18 }}>
          {totalCarriersSelected} carriers selected
        </div>
        <button className="btn btn-primary">
          Start Application
        </button>
      </div>
    </>
  );
}

export default AppetiteSearch;
